import { render, staticRenderFns } from "./scope82.vue?vue&type=template&id=36e1df5e&scoped=true"
import script from "./scope82.vue?vue&type=script&lang=js"
export * from "./scope82.vue?vue&type=script&lang=js"
import style0 from "./scope82.vue?vue&type=style&index=0&id=36e1df5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e1df5e",
  null
  
)

export default component.exports